/**
 * <div is="author-carousel-loader" data-fetch-url="..." data-author-name="..." data-exclude-handle="...">
 *
 * On connect, fetches templates/collection.author-carousel.json rendered
 * against the storefront's Search & Discovery product.authors filter (see
 * sections/featured-collection.liquid for how that template reuses this
 * exact section), replaces the "[author]" placeholder in its heading with
 * the real author name, drops the card for the book currently being viewed
 * (the filter can't exclude it server-side - that render has no idea which
 * PDP is asking), and swaps the whole thing in. Same technique as
 * assets/author-books.js, just targeting this section's own carousel markup
 * instead of the plain collection product grid.
 */
class AuthorCarouselLoader extends HTMLDivElement {
  connectedCallback() {
    const url = this.dataset.fetchUrl;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const authorName = this.dataset.authorName || '';
        const withAuthorName = responseText.split('[author]').join(authorName);

        const parsedHTML = new DOMParser().parseFromString(withAuthorName, 'text/html');
        const carouselSection = parsedHTML.querySelector('[data-featured-collection-carousel]');

        if (!carouselSection) {
          this.showError();
          return;
        }

        const excludeHandle = this.dataset.excludeHandle;
        if (excludeHandle) {
          carouselSection.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            const handle = link.getAttribute('href').split('/products/')[1]?.split(/[/?#]/)[0];
            if (handle === excludeHandle) {
              const card = link.closest('.f-column');
              if (card) card.remove();
            }
          });
        }

        const remainingProductLinks = carouselSection.querySelectorAll(
          '.featured-collection__items a[href*="/products/"]'
        );
        const sectionWrapper = this.closest('.section');

        if (remainingProductLinks.length === 0) {
          if (sectionWrapper) sectionWrapper.remove();
          return;
        }

        if (sectionWrapper) sectionWrapper.replaceWith(carouselSection);
      })
      .catch(() => this.showError());
  }

  showError() {
    this.classList.remove('loading');
    this.innerHTML = `<p class="text-center">${this.dataset.errorText || 'Unable to load books right now.'}</p>`;
  }
}

customElements.define('author-carousel-loader', AuthorCarouselLoader, { extends: 'div' });
